import styled from 'styled-components'

const Label = styled.span`
  position: relative;
  color: #4d566e !important;
  font-weight: 500 !important;
  font-size: 14px;
  text-transform: capitalize;
  letter-spacing: 0.01em;
  ${props => props.labelStyle || ''}
  ${props =>
    props.required &&
    `&::after {
      content: '';
      border-radius: 50%;
      height: 4px;
      width: 4px;
      position: absolute;
      top: 8px;
      margin-left:5px;
      padding-left:2px;
  }`}
  span {
    font-weight: 500;
  }
`
export default Label
